import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
 } from '../../../business-const/Style/Style'

import {
    GridContainer,
    GridItem12,
 } from '../../../business-components/Grid/Grid'

 import {
    CardGridEstudo,
    CardGridDivider,
    CardGridDivHeaderDestaqueAlerta,
    CardGridDivH4Destaque,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

const EstudoFormAlertaCamposObrigatorios = ( { values, handleSubmit } ) => {

    return (
        values.alertaCamposObrigatorios && values.alertaCamposObrigatorios.length > 0
            ?
                <ValidatorForm 
                    onSubmit={handleSubmit}
                    onError={
                        () => null
                    }
                >
                    <GridItem12>
                        <CardGridEstudo>
                            <CardGridDivHeaderDestaqueAlerta>
                                <GridContainer>
                                    <GridItem12>
                                        <CardGridDivH4Destaque>
                                            {LABEL.alertaCamposObrigatorios}
                                        </CardGridDivH4Destaque>
                                    </GridItem12>
                                </GridContainer>
                            </CardGridDivHeaderDestaqueAlerta>
                            
                            <CardGridDivider/>

                            <CardGridDivBody>
                                <br />

                                <GridItem12
                                    className="ml-2"
                                >
                                    {
                                        values.alertaCamposObrigatorios?.map( (linhaAlertaCamposObrigatorios, index) => {
                                            return (
                                                
                                                <span
                                                    key={linhaAlertaCamposObrigatorios}
                                                >
                                                    <h3
                                                        className={CLASSNAME().alertaCamposObrigatorios}
                                                    >
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: linhaAlertaCamposObrigatorios}}
                                                        />
                                                    </h3>
                                                    
                                                    <br/>
                                                </span>
                                            )
                                        })
                                    }
                                </GridItem12>
                            </CardGridDivBody>
                        </CardGridEstudo>
                    </GridItem12>
                </ValidatorForm>
            :
                ''
    )
}

export default EstudoFormAlertaCamposObrigatorios